import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaTimes, FaPlus, FaMusic, FaCheck } from 'react-icons/fa';
import '../styles/AddToPlaylistModal.css';

function AddToPlaylistModal({ track, onClose }) {
  const [playlists, setPlaylists] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newPlaylistName, setNewPlaylistName] = useState('');
  const [showCreate, setShowCreate] = useState(false);
  const [addedTo, setAddedTo] = useState([]);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadPlaylists();
  }, []);

  const loadPlaylists = async () => {
    try {
      const response = await axios.get('/api/playlists');
      setPlaylists(response.data);
    } catch (err) {
      console.error('Erreur chargement playlists:', err);
    } finally {
      setLoading(false);
    }
  };

  const addToPlaylist = async (playlistId) => {
    try {
      setError(null);
      await axios.post(`/api/playlists/${playlistId}/tracks`, {
        track_id: track.id
      });
      setAddedTo([...addedTo, playlistId]);
      setTimeout(() => {
        setAddedTo(prev => prev.filter(id => id !== playlistId));
      }, 2000);
    } catch (err) {
      if (err.response?.status === 400) {
        setError('Piste déjà dans cette playlist');
      } else {
        setError('Erreur lors de l\'ajout');
      }
      setTimeout(() => setError(null), 3000);
    }
  };

  const createAndAdd = async () => {
    if (!newPlaylistName.trim()) return;
    try {
      setError(null);
      const response = await axios.post('/api/playlists', {
        name: newPlaylistName.trim()
      });
      const newPlaylist = response.data;
      
      await axios.post(`/api/playlists/${newPlaylist.id}/tracks`, {
        track_id: track.id
      });

      setPlaylists([newPlaylist, ...playlists]);
      setAddedTo([...addedTo, newPlaylist.id]);
      setNewPlaylistName('');
      setShowCreate(false);

      setTimeout(() => {
        setAddedTo(prev => prev.filter(id => id !== newPlaylist.id));
      }, 2000);
    } catch (err) {
      setError('Erreur lors de la création');
      setTimeout(() => setError(null), 3000);
    }
  };

  return (
    <div className="playlist-modal-overlay" onClick={onClose}>
      <div className="playlist-modal" onClick={(e) => e.stopPropagation()}>
        <div className="playlist-modal-header">
          <h3><FaMusic /> Ajouter à une playlist</h3>
          <button className="playlist-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className="playlist-modal-track">
          <p className="playlist-modal-track-title">{track.title}</p>
          <p className="playlist-modal-track-artist">{track.artist}</p>
        </div>

        {error && <p className="playlist-modal-error">{error}</p>}

        <div className="playlist-modal-list">
          {loading ? (
            <p className="playlist-modal-loading">Chargement...</p>
          ) : playlists.length === 0 && !showCreate ? (
            <p className="playlist-modal-empty">Aucune playlist. Créez-en une !</p>
          ) : (
            playlists.map(playlist => (
              <div
                key={playlist.id}
                className={`playlist-modal-item ${addedTo.includes(playlist.id) ? 'added' : ''}`}
                onClick={() => !addedTo.includes(playlist.id) && addToPlaylist(playlist.id)}
              >
                <div className="playlist-modal-item-info">
                  <span className="playlist-modal-item-name">{playlist.name}</span>
                  <span className="playlist-modal-item-count">
                    {playlist.track_count || 0} piste(s)
                  </span>
                </div>
                {addedTo.includes(playlist.id) ? (
                  <FaCheck className="playlist-modal-item-check" />
                ) : (
                  <FaPlus className="playlist-modal-item-add" />
                )}
              </div>
            ))
          )}
        </div>

        {showCreate ? (
          <div className="playlist-modal-create">
            <input
              type="text"
              placeholder="Nom de la playlist..."
              value={newPlaylistName}
              onChange={(e) => setNewPlaylistName(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && createAndAdd()}
              autoFocus
            />
            <button onClick={createAndAdd} disabled={!newPlaylistName.trim()}>
              <FaCheck />
            </button>
            <button onClick={() => setShowCreate(false)}>
              <FaTimes />
            </button>
          </div>
        ) : (
          <button
            className="playlist-modal-create-btn"
            onClick={() => setShowCreate(true)}
          >
            <FaPlus /> Nouvelle playlist
          </button>
        )}
      </div>
    </div>
  );
}

export default AddToPlaylistModal;
